export function roundEvAmount(value) {
  const amount = Number(value);
  return Number.isFinite(amount) ? Math.round(amount) : 0;
}

export function formatEvMoney(value) {
  return `₹${roundEvAmount(value).toLocaleString("en-IN")}`;
}

export function evDealerDetails(value, assetDetails = {}) {
  const parsedDetails = (input) => {
    if (typeof input !== "string") return input && typeof input === "object" ? input : {};
    try {
      const parsed = JSON.parse(input);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  };
  const details = parsedDetails(value);
  const asset = parsedDetails(assetDetails);
  return {
    ...details,
    name: details.name || asset.dealer_name || "",
    phone: details.phone || "",
    address: details.address || "",
    bank_name: details.bank_name || "",
    bank_branch: details.bank_branch || "",
    account_name: details.account_name || "",
    account_number: details.account_number || "",
    ifsc_code: details.ifsc_code || "",
  };
}
